import React from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "./Logo";
import SIXChat from "./SIXChat";
import MotionToggle from "./cinematic/MotionToggle";

export default function PublicFooter() {
  const loc = useLocation();
  return (
    <>
      <footer
      className="border-t mt-24"
      style={{ borderColor: "var(--dt6-border)", background: "var(--dt6-surface)" }}
      data-testid="public-footer"
    >
      <div className="max-w-7xl mx-auto px-6 py-12 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <Logo size={26} />
          <p className="mt-4 text-sm text-[color:var(--dt6-muted)] max-w-xs">
            Six weapons. One stack. Political data infrastructure for America-First campaigns, PACs, and movements.
          </p>
        </div>
        <div>
          <h4 className="font-mono text-[0.7rem] tracking-[0.14em] uppercase text-[color:var(--dt6-muted)] mb-3">Platform</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/platform" className="hover:text-[color:var(--dt6-primary)]">Full stack</Link></li>
            <li><Link to="/pricing" className="hover:text-[color:var(--dt6-primary)]">Pricing</Link></li>
            <li><Link to="/partners" className="hover:text-[color:var(--dt6-primary)]">Partners</Link></li>
            <li><Link to="/audit" className="hover:text-[color:var(--dt6-primary)]">Free file audit</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-mono text-[0.7rem] tracking-[0.14em] uppercase text-[color:var(--dt6-muted)] mb-3">Modules</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/modules/D1" className="hover:text-[color:var(--dt6-primary)]"><span className="font-mono text-[color:var(--dt6-muted)] mr-2">D1</span>Source</Link></li>
            <li><Link to="/modules/D2" className="hover:text-[color:var(--dt6-primary)]"><span className="font-mono text-[color:var(--dt6-muted)] mr-2">D2</span>Clean</Link></li>
            <li><Link to="/modules/D3" className="hover:text-[color:var(--dt6-primary)]"><span className="font-mono text-[color:var(--dt6-muted)] mr-2">D3</span>Identify</Link></li>
            <li><Link to="/modules/D4" className="hover:text-[color:var(--dt6-primary)]"><span className="font-mono text-[color:var(--dt6-muted)] mr-2">D4</span>Score</Link></li>
            <li><Link to="/modules/D5" className="hover:text-[color:var(--dt6-primary)]"><span className="font-mono text-[color:var(--dt6-muted)] mr-2">D5</span>Route</Link></li>
            <li><Link to="/modules/D6" className="hover:text-[color:var(--dt6-primary)]"><span className="font-mono text-[color:var(--dt6-muted)] mr-2">D6</span>Activate</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-mono text-[0.7rem] tracking-[0.14em] uppercase text-[color:var(--dt6-muted)] mb-3">Legal</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/privacy" className="hover:text-[color:var(--dt6-primary)]">Privacy</Link></li>
            <li><Link to="/terms" className="hover:text-[color:var(--dt6-primary)]">Terms</Link></li>
            <li><Link to="/dsar" className="hover:text-[color:var(--dt6-primary)]">Data subject request</Link></li>
            <li><Link to="/compliance" className="hover:text-[color:var(--dt6-primary)]">Compliance posture</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t py-4 flex flex-col md:flex-row-reverse items-center justify-between gap-3 px-6 font-mono text-[0.7rem] tracking-[0.14em] uppercase text-[color:var(--dt6-muted)]" style={{ borderColor: "var(--dt6-border)" }}>
        {/* SIX launcher lives at fixed bottom-6 right-6.  Placing the copyright
            on the right and the motion toggle on the LEFT of the footer keeps
            the toggle out of the launcher's 60px overlap quadrant. */}
        <span>© {new Date().getFullYear()} DT6 — POLITICAL DATA INFRASTRUCTURE.</span>
        <MotionToggle />
      </div>
    </footer>
    <SIXChat face="concierge" variant="floating" pageContext={loc.pathname} />
    </>
  );
}
